export const TransactionTypes = [
  { text: 'DA paiement et réponse', value: ['0100-00xxxx', '0100-90xxxx', '0101-00xxxx'] },
  { text: 'DA retrait et réponse', value: ['0100-01xxxx', '0101-01xxxx'] },
  { text: 'DA crédit et réponse', value: ['0100-20xxxx', '0101-20xxxx'] },
  { text: 'Avis DA paiement et réponse', value: ['0120-00xxxx', '0121-00xxxx'] },
  { text: 'Avis DA retrait et réponse', value: ['0120-01xxxx', '0121-01xxxx'] },
  { text: 'Avis DA crédit', value: ['0120-20xxxx', '0121-20xxxx'] },
  { text: 'Redressement technique interne', value: ['0420-xx9999'] },
  { text: 'Annulation et redressement paiement', value: ['0400-00xxxx', '0401-00xxxx', '0400-90xxxx', '0400-95xxxx'] },
  { text: 'Redressement retrait', value: ['0400-01xxxx', '0401-01xxxx'] },
  { text: 'Annulation et redressement crédit', value: ['0400-20xxxx', '0401-20xxxx'] },
  { text: 'Annulation technique interne (GS WL)', value: ['0420-xx8888'] },
  { text: 'Annulation technique interne (Distributeur)', value: ['0420-xx7777'] }
]
